import { Component, OnInit} from '@angular/core';
import { CmSection, ContentType , CmElement} from '../shared/model/cm/managed-content.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { UserSessionService } from '../shared/service/user-session.service';
import { PolicyService } from '../shared/service/policy.service';
import { GroupService } from '../shared/service/group.service';
import { GlobalConstants } from '../shared/global-constants';
import { MhsApplication } from '../shared/model/mhs-application';
import { AppInsightsApiService} from "../shared/service/app-insights-api.service";
import { MhsService } from '../shared/service/mhs.service';
import { AuthGuardService } from '../shared/service/auth-guard.service';
import { PagetitleService } from '../shared/service/pagetitle.service';
import defaultCoverages from '../../assets/demo/coverages/defaultCoverages.json';
import { GroupEdp } from '../shared/model/group-edp';
import { Notice } from '../shared/model/session/notice';
import { AgencyLocation } from '../shared/model/agency-location';
import { CUSTOM_ELEMENTS_SCHEMA, DoCheck } from '@angular/core';

import { RouterService } from '../shared/service/router.service';
import { ModalService } from '../shared/service/modal.service';
import { GoogleAnalyticsService } from '../shared/service/google-analytics.service';
import { MaintenanceNotificationComponent } from '../maintenance-notification/maintenance-notification.component';
import { AmuTimerService } from '../shared/service/amu-timer.service';
import { delay } from 'rxjs/operators';
@Component({
  selector: 'app-instructions',
  standalone: true,
  imports: [MaintenanceNotificationComponent],
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InstructionsComponent implements OnInit, DoCheck {

  public readonly pageIllustrationUrl = 'assets/Illustration-Header-Base-Mountains.svg'

  instructionsContent: CmSection;
  gatherContent: CmSection;
  gatherContentDigitPolicy: CmSection;
  gatherContentCoverage: CmSection;
  gatherContentMedical: CmSection;
  sessionContent: CmSection;
  evidenceContent: CmSection;
  ceoiPolicyFlagContent: CmSection;
   pageLoaderElement: CmElement;
  showTimeoutMessage = false;
  public evidenceRequired: boolean = true;
  public ceoiPolicyFlag: boolean = false;
  public isCustumUrl: boolean = false;
  public noEvidenceRequiredText: String = "";
  public ceoiPolicyFlagTitle: String = "";
  public ceoiPolicyFlagBody: String = "";
  public readonly alertLogoUrl = GlobalConstants.alertLogo;
  public hasPolicyId: boolean = false;
  isNM: boolean = false;
  isApiResponse: boolean =false;
  agencyLocations: AgencyLocation[];
  agencyLocationNames: string[] = [];

  public prismButtonProps = {
    keyId: 'start-button',
    size: 'large',
    text: 'Start the Statement',
    type: 'submit',
    variant: 'primary'
  }

  

  public onSubmit(): void {
    // get policy info
    let policyId: number =0;
    this.activatedRoute.paramMap.subscribe(params => {
      policyId = Number(params.get(GlobalConstants.CUSTOM_URL_PARAM_NAME));
    });
    if(policyId!=0){
      if(this.policyService){
        this.isApiResponse = true;
        this.policyService.getPolicyDataFor(policyId).subscribe(
          async response => {
            this.isApiResponse = false;
            let edpGroup = new GroupEdp();
            edpGroup = response;
             this.ceoiPolicyFlag = edpGroup.ceoiPolicy;

              if(this.ceoiPolicyFlag){
                let endPart: string = this.ceoiPolicyFlagContent.body;
                  endPart = endPart.replace('<p>', "");
                  endPart = endPart.replace('</p>', "");
                  this.ceoiPolicyFlagBody = endPart;
                  sessionStorage.setItem(GlobalConstants.CEOI_POLICY_FLAG, this.ceoiPolicyFlag+'');
              }
            // make sure the company ID of the group matches the companyID on the userSession
            let carrier = this.userSessionService.data.dataTheme;
            let result = await this.policyService.checkTheCompanyIdMatchesExpectedCompanyId(edpGroup.companyId, carrier);
            if(result && !this.ceoiPolicyFlag){
            // if(result && !ceoiPolicyresult){
                this.evidenceRequired = edpGroup.evidenceRequired;

                if(this.evidenceRequired){
                
                  // Set policyId in sessionStorage
                  sessionStorage.setItem(GlobalConstants.CUSTOM_URL_PARAM_NAME, policyId+'');
  
                  // Set session data
                  this.userSessionService.data.policy = policyId;
  
                  // set default products if none came back from edp
                  if(edpGroup.productsByApplicantType.length === 0){
                    edpGroup.productsByApplicantType = defaultCoverages.productsByApplicantType;
                  }
                  this.userSessionService.data.edpGroupData = edpGroup;
  
                  if(edpGroup.groupName){
                    this.userSessionService.data.grpName = edpGroup.groupName;
                  }
  
                  this.agencyLocations = edpGroup.adminUnits;
                  this.userSessionService.data.agencyLocations = this.agencyLocations;
  
                  if(this.agencyLocations.length == 1){
                    this.userSessionService.data.agencyLocation = this.agencyLocations[0].id.toString();
                  }
  
                  let completedApp = new MhsApplication();
                  this.userSessionService.data.mhsApplication = completedApp;
                  completedApp.policyNumber = policyId+'';
                  this.userSessionService.data.mhsApplication = completedApp;
  
                  if(response.companyId){
                    this.userSessionService.data.companyId = response.companyId;
                    this.userSessionService.data.mhsApplication.companyId = response.companyId;
  
                    if(response.companyId == 'YI'){
                      this.userSessionService.data.state = "NY";
                      if(this.policyService){
                        this.policyService.isYiPolicyRedirected(false);
                      }
                      if(this.pagetitleService){
                        this.pagetitleService.setIsYiPolicy(true);
                      }
                    } else {
                      if(this.pagetitleService){
                        this.pagetitleService.setIsYiPolicy(false);
                      }
                    }
                  }
  
                  if(response.productsByApplicantType){
                    this.userSessionService.data.applicantTypes = response.productsByApplicantType;
                  } else {
                    this.userSessionService.data.edpGroupData = defaultCoverages;
                  }
  
                } else {
                  let endPart: string = this.evidenceContent.body;
                  endPart = endPart.replace('<p>', "");
                  endPart = endPart.replace('</p>', "");
                  this.noEvidenceRequiredText = 'The policy #' + policyId + " " + endPart;
                }
              
              this.googleAnalyticsService.sendCustomEvent(this.startStatement);
              this.router.navigate(['/policy']); 
              this.appInsightsApiService.startNavigationEvent(this.router.currentNavigation().extractedUrl.toString());
  
            } else if (this.ceoiPolicyFlag){
              // do nothing land on same instruction page
              this.handleInvalidPolicy();
            }else {
              this.handleInvalidPolicy();
            }
          },
          err => {
            this.handleInvalidPolicy(err);
          }
        );
      }
    }else{
      this.googleAnalyticsService.sendCustomEvent(this.startStatement);
      this.router.navigate(['/policy']); 
      this.appInsightsApiService.startNavigationEvent(this.router.currentNavigation().extractedUrl.toString());
  
    }

  }

  // GA4 Custom events
  public startStatement = {
    action: "button_click",
    category: "instructions",
    name: "startStatement",
  }

  constructor(private router: Router,
              private cmService: ManagedContentService,
              private activatedRoute: ActivatedRoute,
              private policyService: PolicyService,
              private userSessionService: UserSessionService,
              private groupService: GroupService,
              private appInsightsApiService: AppInsightsApiService,
              private googleAnalyticsService: GoogleAnalyticsService,
              private mhsService: MhsService,
              private authGuardService: AuthGuardService,
              private pagetitleService: PagetitleService,
              private routerService: RouterService,
              private modalService: ModalService,
              private amuTimerService: AmuTimerService
              ) {}

  ngOnInit() {
    this.amuTimerService.startOrStopTimer(false);
    this.amuTimerService.stopWatching();
    this.routerService.setRoute(this.router.url);
    this.appInsightsApiService.startNavigationEvent(this.router.url);
    this.userSessionService.data.sessionEnded = false;
    this.showTimeoutMessage = this.userSessionService.data.sessionTimedOut;
    this.modalService.closeModal('prism-ui-modal-timer-modal');
    this.modalService.closeModal('prism-ui-modal-error-modal');
    this.instructionsContent = this.cmService.getContentById(ContentType.SECTION, "eeoi-instructions");
    this.gatherContent = this.cmService.getContentById(ContentType.SECTION, "eeoi-gather-title");
    this.gatherContentDigitPolicy = this.cmService.getContentById(ContentType.SECTION, "eeoi-gather-digit-policy");
    this.gatherContentCoverage = this.cmService.getContentById(ContentType.SECTION, "eeoi-gather-coverage");
    this.gatherContentMedical = this.cmService.getContentById(ContentType.SECTION, "eeoi-gather-medical");
    
    this.sessionContent = this.cmService.getContentById(ContentType.SECTION, "eeoi-session");
    this.evidenceContent = this.cmService.getContentById(ContentType.SECTION, "eeoi-evidence-not-required-instructions");
    this.ceoiPolicyFlagContent = this.cmService.getContentById(ContentType.SECTION, "do-not-apply-here");
   
   this.pageLoaderElement = this.cmService.getContentById(ContentType.ELEMENT, "policy-number-generic-loader");
    this.userSessionService.data.edpGroupData = defaultCoverages;

    let policyId;

    this.activatedRoute.paramMap.subscribe(params => {
      policyId = params.get(GlobalConstants.CUSTOM_URL_PARAM_NAME);
      this.isCustumUrl = !!policyId;
    });

    //hide NM MA/NY PDF forms for other carriers
    if (this.userSessionService.data.dataTheme != 'nwm'){
      this.isNM = false;
    } else {
      this.isNM = true;
    }

    if(!policyId){
      policyId = sessionStorage.getItem(GlobalConstants.CUSTOM_URL_PARAM_NAME);
      if(policyId){
        this.router.navigate([policyId]);
      }
    }

    this.pagetitleService.setPageTitle('Instructions');

    if(policyId != null){
  this.appInsightsApiService.endNavigationEvent(this.router.url);

    //cleanup from a potential prior application
    this.mhsService.updateSubmission(false);
    this.mhsService.resubmitEmployeeInfo(false);
    this.mhsService.resubmitApplicantInfo(false);
    this.mhsService.resubmitPhysician(false);
    this.mhsService.resubmitAuthSign(false);
    this.mhsService.resubmitMedicalHistory(false);
    this.mhsService.physicianErrorThrown = false;
    this.mhsService.updateThrowPhysicianError(false);
      
    } else {
      this.userSessionService.clearSession();
    }

    
  }

  handleInvalidPolicy(msg?: string){
    sessionStorage.removeItem(GlobalConstants.CUSTOM_URL_PARAM_NAME);
    this.userSessionService.clearSession(); // clear session retains companyId
    this.router.navigate(['/invalid-policy-number']);
  }

  ngDoCheck(){
    let policyId = sessionStorage.getItem(GlobalConstants.CUSTOM_URL_PARAM_NAME);

    if(policyId != null){
      this.gatherContent = this.cmService.getContentById(ContentType.SECTION, "eeoi-gather-custom");
      this.hasPolicyId = true;
    } else {
      this.gatherContent = this.cmService.getContentById(ContentType.SECTION, "eeoi-gather-title");
      this.hasPolicyId = false;
    }
  }

  startApplication(){
    this.router.navigate(['/policy']);
  }

}